import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Badge,
  Card,
  CardBody,
  Col,
  Row,
  Container,
  UncontrolledTooltip,
} from "reactstrap";
import TableContainer from "Components/Common/TableContainer";
import toastr from "toastr";
import { numberWithCommas } from "../../helpers/globalHelper";
import {
  useNotificationFindAllQuery,
  useNotificationMarkReadMutation,
} from "store";

const NotificationList = ({ searchField }: any) => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState<any[]>([]);
  const [customQuery, setCustomQuery] = useState<string>();
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<number>();
  const [customPageLength, setCustomPageLength] = useState<number>();

  const { data } = useNotificationFindAllQuery(customQuery);
  const [markRead] = useNotificationMarkReadMutation();

  useEffect(() => {
    setNotifications(data?.data || []);
    setCustomPagination(data?.pagination);

    const query = `?page=${customPageLength || 1}&pageSize=${customPageSize || 25}${
      searchField ? `&${searchField}` : ""
    }`;
    setCustomQuery(query);
  }, [data, searchField, customPageSize, customPageLength]);

  const handleMarkRead = async (notification: any) => {
    if (!notification?.is_read) {
      markRead(notification.notification_id).unwrap();
      setNotifications((prev) =>
        prev.map((n) => (n.id === notification.id ? { ...n, is_read: true } : n))
      );
    }

    if (notification?.notification?.redirect_url) {
      navigate(notification.notification.redirect_url);
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "#",
        accessorKey: "notification_id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({row}) => <div style={{ textAlign: "left" }}>{row.original.notification_id}</div>
      },
      {
        header: "Тайлбар",
        accessorKey: "message",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({row}) => <div style={{ textAlign: "left" }}>{row.original?.notification?.message}</div>
      },
      {
        header: "Огноо",
        accessorKey: "created_at",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({row}) => <div style={{ textAlign: "left" }}>{row.original?.created_at}</div>
      },
      {
        header: "Уншсан",
        accessorKey: "is_read",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (props: any) =>
          props.row.original?.is_read ? (
            <Badge color="success">Тийм</Badge>
          ) : (
            <Badge color="warning">Үгүй</Badge>
          ),
      },
      {
        header: "Үйлдэл",
        cell: (props: any) => (
          <ul className="list-unstyled hstack gap-1 mb-0">
            <li>
              <Link
                to="#"
                className="btn btn-sm btn-soft-success"
                id="gotooltip"
                onClick={(e) => {
                  e.preventDefault()
                  handleMarkRead(props.row.original)
                }}
              >
                <i className="mdi mdi-link" />
              </Link>
              <UncontrolledTooltip placement="top" target="gotooltip">
                Холбоосруу очих
              </UncontrolledTooltip>
            </li>
          </ul>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <React.Fragment>
              <Col xl={9}>
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1 ms-3">
                        <h5 className="fw-semibold">Мэдэгдлүүд</h5>
                        <ul className="list-unstyled hstack gap-2 mb-0">
                          <li>
                            <span className="text-muted fw-semibold">
                              Нийт: {numberWithCommas(notifications.length)}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </CardBody>

                  <CardBody>
                    <TableContainer
                      setCustomPageSize={setCustomPageSize}
                      setCustomPageLength={setCustomPageLength}
                      customPagination={customPagination}
                      columns={columns}
                      data={notifications || []}
                      isCustomPageSize={true}
                      isPagination={true}
                      colWidth={2}
                      SearchPlaceholder="Мэдэгдэл хайх..."
                      tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            </React.Fragment>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NotificationList;